import React, { useState, useEffect, useRef } from 'react'
// import CommonTablePage from '../../../components/common/common-table/common-table-page'
import CommonTablePageWithSortPreserve from '../../../components/common/common-table/common-table-page-with-sort-preserve'

import { urlKey, urlType } from '../../../services/api/api-urls'
import CustomerManagementColumnModel from './customer-management-column-model'
import { ApiRequest } from '../../../services/api/api'
import { baseUrl } from '../../../services/api/base-url'
import QuotationManagementPage from '../quotation-management-page/quotation-management-page'
import CommonDialog from '../../../components/common/others/common-dialog'
import SalesOrderManagementPage from '../../order/sales-order/sales-order-management-page'
import ExtraAddressManagementPage from './extra-address-management-page/extra-address-management-page'
import ContactManagementPage from './contact-management-page/contact-management-page'
import {getRandomKey} from '../../../services/lib/utils/helpers'
import SweetAlertService from '../../../services/lib/utils/sweet-alert-service'
import CustomerFilePage from './customer-file-page/customer-file-page'
import { ContactsOutlined, FilePdfOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import './customer-management.css'
import { sendEmail } from '../../../services/others/quotation-email-services'
import moment from 'moment'
import Swal from 'sweetalert2'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'
import { getUserId } from '../../../services/lib/utils/auth.utils'
import { buildUpdateCustomerStatusUrl } from './update-customer-status-url'

// 独立的 Footer 组件，通过轮询从 tableRef 获取数据
const CustomerStatsFooter = ({ tableRef, originalTotalCount, originalActiveCount }: {
  tableRef: any
  originalTotalCount: number
  originalActiveCount: number
}) => {
  const [selectedCount, setSelectedCount] = useState(originalActiveCount)

  // 当 originalActiveCount 更新且没有过滤时，同步更新 selectedCount
  useEffect(() => {
    if (tableRef?.current) {
      const state = tableRef.current.state
      const hasSearch = state?.searchText && state.searchText.length > 0
      const hasFilters = state?.filters && Object.keys(state.filters).length > 0
      const hasColumnFilters = state?.columns?.some((col: any) => col.tableData?.filterValue)

      if (!hasSearch && !hasFilters && !hasColumnFilters) {
        setSelectedCount(originalActiveCount)
      }
    }
  }, [originalActiveCount, tableRef])

  useEffect(() => {
    // 轮询获取当前过滤后的数据数量
    const pollFilteredCount = () => {
      if (tableRef?.current) {
        const dataManager = tableRef.current.dataManager
        const state = tableRef.current.state

        // 检查是否有搜索或过滤
        const hasSearch = state?.searchText && state.searchText.length > 0
        const hasFilters = state?.filters && Object.keys(state.filters).length > 0
        const hasColumnFilters = state?.columns?.some((col: any) => col.tableData?.filterValue)

        // 根据搜索/过滤状态选择正确的数据源
        let currentData: any[] = []

        // 优先级：sortedData (包含搜索+过滤+排序) > searchedData (搜索+过滤) > filteredData (仅过滤) > data (原始)
        if (hasSearch || hasFilters || hasColumnFilters) {
          // 有搜索或过滤时，使用处理后的数据
          if (dataManager?.sortedData && dataManager.sortedData.length > 0) {
            currentData = dataManager.sortedData
          } else if (dataManager?.searchedData && dataManager.searchedData.length > 0) {
            currentData = dataManager.searchedData
          } else if (dataManager?.filteredData && dataManager.filteredData.length > 0) {
            currentData = dataManager.filteredData
          }
        }

        // 如果没有搜索/过滤，使用 Active Customers 数量
        if (!hasSearch && !hasFilters && !hasColumnFilters) {
          setSelectedCount(originalActiveCount)
        } else {
          // 有过滤时，如果上述数据为空，使用原始数据
          if (currentData.length === 0 && dataManager?.data) {
            currentData = dataManager.data
          }
          setSelectedCount(currentData.length)
        }
      }
    }

    // 立即执行一次
    pollFilteredCount()

    // 每 300ms 检查一次
    const intervalId = setInterval(pollFilteredCount, 1000)

    return () => clearInterval(intervalId)
  }, [tableRef, originalActiveCount])

  return (
    <div style={{
      marginTop: "20px",
      padding: "12px 20px",
      background: "#fafafa",
      borderTop: "1px solid #ddd",
      fontSize: "15px",
      display: "flex",
      gap: "40px",
    }}>
      <div>
        Customer Total: <b>{originalTotalCount}</b>
      </div>
      <div>
        Active Customers: <b style={{ color: "green" }}>{originalActiveCount}</b>
      </div>
      <div>
        Selected Customers: <b style={{ color: "#1890ff" }}>{selectedCount}</b>
      </div>
    </div>
  )
}


const CustomerManagementPage = (props: {salesId?: any, salesView?: boolean}): any => {
  const [triggerResetData, setTriggerResetData] = useState<any>(false)
  const [open, setOpen] = useState(false)
  const [dialogContent, setDialogContent] = useState<any>()
  const [dialogTitle, setDialogTitle] = useState<any>()
  // 原始数据统计（filter 之前）
  const [originalTotalCount, setOriginalTotalCount] = useState(0);
  const [originalActiveCount, setOriginalActiveCount] = useState(0);

  // 管理表格数据的state
  const [displayData, setDisplayData] = useState<any[] | undefined>(undefined) // undefined 表示使用API加载数据
  const [isInitialized, setIsInitialized] = useState(false)

  // 创建 tableRef 传递给 CommonTablePage，让 Footer 组件可以访问
  const tableRef = useRef<any>(null)

  let isCreate = false
  useDocumentTitle();

  // useEffect(() => {
  //   if (props.salesId) document.title = "Customer Management"; 
  //   else if (props.salesView) document.title = "Customer";
  //   else document.title = "Customer Admin Management";
  // }, [])

  const resetData = () => {
    // 清除搜索状态
    originalDataRef.current = []
    isSearchingRef.current = false
    searchTextRef.current = ''
    setDisplayData(undefined) // undefined 让组件重新调用API
    setIsInitialized(false)
    setTriggerResetData(getRandomKey())
  }

  const attachmentManagementDialog = (customerId: any) => <CustomerFilePage customerId={customerId}  />

  const quotationManagementDialog = (customerId: any) => <QuotationManagementPage customerId={customerId} />

  const orderManagementDialog = (customerId: any) => <SalesOrderManagementPage customerId={customerId} />

  const extraAddrDialog = (customerId: any) => <ExtraAddressManagementPage customerId={customerId} isReadOnly={props.salesView} />

  const contactDialog = (customerId: any) => <ContactManagementPage customerId={customerId} isReadOnly={props.salesView} />

  const sendEmailToSales = (rawData:any,targetAddress:string,resultNote:string,status:number ) => {
    // const targetAddress = rawData.employee.email;
    const senderAddress = "Edwin@gradspace.org";
    const title = (status == 1)
      ? "Attention: Customer's account is Activated" :"Attention: Customer's account is Deactivated/Locked";
    const customerName = rawData.customerCode+"/"+rawData.company; 
    const profileNote = resultNote; 
    const deactivationTime = moment().format('DD/MM/YYYY');
    
    let HtmlContent = `
    <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            background-color: #f4f4f4;
            margin: 0;
            padding: 0;
          }
          .container {
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
            background-color: #ffffff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }
          h1 {
            color: #333;
          }
          p {
            color: #555;
            line-height: 1.4;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <h1>Customer Account Deactivated/Locked</h1>
          <p>Please contact the accountant for more details and follow-up.</p>
          <p><strong>Customer Info: </strong> ${customerName}</p>
          <p><strong>Profile Note: </strong> ${profileNote}</p>
          <p><strong>Time Deactivated/Locked: </strong> ${deactivationTime}</p>
        </div>
      </body>
    </html>
    `;
    if (status == 1) {
      HtmlContent = HtmlContent.replaceAll("Deactivated/Locked", "Activated");
    }

    const formData = new FormData();
    formData.append('SenderName', 'Jadcup Admin');
    formData.append('SenderAddress',senderAddress);
    formData.append('TargetAddress', targetAddress);
    formData.append('Subject', title);
    formData.append('HtmlContent', HtmlContent);

    return sendEmail(formData)
      .then((res) => {
        if (res.data.isSuccessStatusCode === false) {
          SweetAlertService.errorMessage("Send email fail!");
        }
      });
  };
  const isValidEmail = (email:string) => {
    // Regular expression for basic email validation
    if (!email) return false;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  }
  const updateCustomerStatus = async (rowData: any, statusId: any) => {
        const currentStatusId = rowData.status?.statusId || 2;
        const currentStatusName = rowData.status?.statusName || 'Inactive';
        const currentStatus = currentStatusName;

        // 根据状态ID返回对应的颜色
        const getStatusColor = (statusId: number) => {
          const colorMap: { [key: number]: string } = {
            1: '#52c41a',    // Active - 绿色
            2: '#1890ff',    // Prospect - 蓝色
            3: '#722ed1',    // Lead - 紫色
            4: '#faad14',    // On hold - 橙色
            5: '#f5222d',    // Lost - 红色
            6: '#8c8c8c',    // Close - 灰色
            7: '#fa8c16'     // Unconfirmed - 深橙色
          };
          return colorMap[statusId] || '#8c8c8c'; // 默认灰色
        };

        // 从 API 获取所有可用的客户状态
        let statusOptions: any[] = [];
        try {
          const response = await ApiRequest({
            url: 'CustomerStatus/GetAllCustomerStatus',
            method: 'get',
            isShowSpinner: false
          });
          statusOptions = response?.data?.data || [];
        } catch (error) {
          console.error('Failed to fetch customer statuses:', error);
          // 如果 API 失败，使用默认状态选项
          statusOptions = [
            { statusId: 1, statusName: 'Active' },
            { statusId: 2, statusName: 'Inactive' }
          ];
        }

        // 如果没有获取到状态，使用默认选项
        if (statusOptions.length === 0) {
          statusOptions = [
            { statusId: 1, statusName: 'Active' },
            { statusId: 2, statusName: 'Inactive' }
          ];
        }

        const result = await Swal.fire({
        title: `Change Customer`,
        html: `
        <div class="swal-input-container" style="text-align: left;">
          <div style="margin-bottom: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 4px;">
            <div style="margin-bottom: 8px; font-weight: bold; color: #333;">Customer:</div>
            <div>${rowData.customerCode || rowData.company}</div>
          </div>

          <div style="margin-bottom: 16px; padding: 12px; background-color: #e6f7ff; border-radius: 4px;">
            <div style="font-weight: bold; color: #333; margin-bottom: 4px;">Current Status:</div>
            <div style="font-size: 16px; font-weight: 600; color: ${getStatusColor(currentStatusId)};">${currentStatus}</div>
          </div>

          <div class="swal-input-container">
            <label for="statusSelect" style="color: Black; font-weight: bold; display: block; margin-bottom: 8px;">Select New Status:</label>
            <select id="statusSelect" style="width: 100%; padding: 10px; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 14px;">
              <option value="">-- Select Status --</option>
              ${statusOptions.map((status: any) => `
                <option value="${status.statusId}" ${currentStatusId === status.statusId ? 'disabled' : ''}>
                  ${status.statusName}
                </option>
              `).join('')}
            </select>
            <div style="margin-top: 8px; font-size: 12px; color: #999;">
              Current: ${currentStatus} - Click to select different status
            </div>
          </div>

          <div class="swal-input-container">
            <label for="Note" style="color: Black; font-weight: bold;">Profile Note <span id="noteRequired" style="font-weight: normal; color: #999;">(optional)</span>:</label>
          </div>
          <div class="swal-input-container">
            <textarea id="Note" rows="4" placeholder="Enter reason for status change..." style="width: 100%; padding: 8px; border: 1px solid #d9d9d9; border-radius: 4px;">${rowData.notes || ''}</textarea>
          </div>

          <div class="swal-input-container">
            <label for="Email" style="color: Black; font-weight: bold;">Notification Email <span id="emailRequired" style="font-weight: normal; color: #999;">(optional)</span>:</label>
          </div>
          <div class="swal-input-container">
            <input id="Email" type="email" value="${rowData.employee?.email || ''}" placeholder="Enter notification email address" style="width: 100%; padding: 8px; border: 1px solid #d9d9d9; border-radius: 4px;">
          </div>

          <div class="swal-input-container">
            <label for="UnconfirmDate" style="color: Black; font-weight: bold;">Unconfirm Date <span id="dateRequired" style="font-weight: normal; color: #999;">(optional)</span>:</label>
          </div>
          <div class="swal-input-container">
            <input id="UnconfirmDate" type="date" value="${rowData.unconfirmDate ? rowData.unconfirmDate.split('T')[0] : ''}" placeholder="Select unconfirm date" style="width: 100%; padding: 8px; border: 1px solid #d9d9d9; border-radius: 4px;">
          </div>

          <div style="margin-top: 16px; padding: 12px; background-color: #e6f7ff; border: 1px solid #91d5ff; border-radius: 4px; font-size: 12px; color: #0050b3;">
            <strong>Note:</strong> You can update either the status or the unconfirm date, or both. At least one field must be provided.
          </div>
        </div>
      `,
        onOpen: () => {
          // 禁用 SweetAlert2 的默认输入样式
          const style = document.createElement('style');
          style.innerHTML = `
            .swal-input-container { margin-bottom: 12px; }
            #statusSelect { cursor: pointer; }
            #statusSelect:disabled { cursor: not-allowed; opacity: 0.6; }
            #statusSelect option:disabled { display: none; }
          `;
          document.head.appendChild(style);

          // 添加状态选择变更监听器
          const statusSelect = document.getElementById('statusSelect') as HTMLSelectElement;
          const noteRequired = document.getElementById('noteRequired');
          const emailRequired = document.getElementById('emailRequired');

          const updateRequiredLabels = () => {
            const newStatusId = statusSelect?.value ? parseInt(statusSelect.value, 10) : null;
            const isUpdatingStatus = newStatusId && newStatusId !== currentStatusId;

            if (noteRequired && emailRequired) {
              if (isUpdatingStatus) {
                noteRequired.textContent = '(required)';
                emailRequired.textContent = '(required)';
              } else {
                noteRequired.textContent = '(optional)';
                emailRequired.textContent = '(optional)';
              }
            }
          };

          statusSelect?.addEventListener('change', updateRequiredLabels);
          updateRequiredLabels(); // 初始化
        },
        preConfirm: () => {
          const statusSelect = document.getElementById('statusSelect') as HTMLSelectElement;
          const newStatusId = statusSelect?.value ? parseInt(statusSelect.value, 10) : null;

          const unconfirmDateInput = document.getElementById('UnconfirmDate') as HTMLInputElement;
          const unconfirmDate = unconfirmDateInput?.value || '';

          const Note = (document.getElementById('Note') as HTMLInputElement)?.value || '';
          const Email = (document.getElementById('Email') as HTMLInputElement)?.value || '';

          // 验证至少有一个字段有值
          const isUpdatingStatus = newStatusId && newStatusId !== currentStatusId;
          const isUpdatingDate = !!unconfirmDate;

          if (!isUpdatingStatus && !isUpdatingDate) {
            Swal.showValidationMessage('Please select a new status or an unconfirm date (or both)');
            return false;
          }

          // 状态相关验证
          if (isUpdatingStatus) {
            if (newStatusId === currentStatusId) {
              Swal.showValidationMessage('New status must be different from current status');
              return false;
            }

            if (!Note || !Note.trim()) {
              Swal.showValidationMessage('Please enter a profile note when changing status');
              return false;
            }

            if (!Email || !Email.trim()) {
              Swal.showValidationMessage('Please enter an email address when changing status');
              return false;
            }

            if (!isValidEmail(Email)) {
              Swal.showValidationMessage('Please enter a valid email address');
              return false;
            }
          }

          return { statusId: newStatusId, Note, Email, unconfirmDate };
        },
        showCancelButton: true,
        confirmButtonText: 'Confirm Change',
        cancelButtonText: 'Cancel',
        focusConfirm: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          container: 'custom-swal-container',
          confirmButton: 'custom-swal-confirm-button',
          cancelButton: 'custom-swal-cancel-button'
        }
      });

      if (result.isConfirmed) {
        const { statusId: newStatusId, Note = "", Email = "", unconfirmDate = "" } = result.value || {};
        const selectedStatus = statusOptions.find((s: any) => s.statusId === newStatusId);
        const finalActionText = selectedStatus?.statusName || 'Change';

        // 确定更新类型
        const isUpdatingStatus = newStatusId != null && newStatusId !== currentStatusId;
        const isUpdatingDate = !!unconfirmDate;

        // 根据更新类型构建确认信息
        let confirmTitle = '';
        let confirmHtml = '';

        if (isUpdatingStatus && isUpdatingDate) {
          // 同时更新status和date
          confirmTitle = 'Confirm Status Change';
          confirmHtml = `
            <div style="text-align: left;">
              <p>Are you sure you want to change the customer status and set unconfirm date?</p>
              <div style="margin-top: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 4px;">
                <div style="font-weight: bold; margin-bottom: 4px;">Customer:</div>
                <div>${rowData.customerCode || rowData.company}</div>
                <div style="margin-top: 8px; font-weight: bold; margin-bottom: 4px;">Status Change:</div>
                <div style="color: ${getStatusColor(currentStatusId)};">${currentStatus}</div>
                <div style="margin-top: 4px; font-weight: bold; margin-bottom: 4px;">To:</div>
                <div style="color: ${getStatusColor(newStatusId)}; font-weight: 600;">${selectedStatus?.statusName}</div>
                <div style="margin-top: 8px; font-weight: bold; margin-bottom: 4px;">Reason:</div>
                <div style="font-style: italic;">${Note}</div>
                <div style="margin-top: 8px; font-weight: bold; margin-bottom: 4px;">Unconfirm Date:</div>
                <div>${moment(unconfirmDate).format('DD/MM/YYYY')}</div>
              </div>
            </div>
          `;
        } else if (isUpdatingStatus) {
          // 只更新status
          confirmTitle = 'Confirm Status Change';
          confirmHtml = `
            <div style="text-align: left;">
              <p>Are you sure you want to change the customer status to <strong>${selectedStatus?.statusName}</strong>?</p>
              <div style="margin-top: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 4px;">
                <div style="font-weight: bold; margin-bottom: 4px;">Customer:</div>
                <div>${rowData.customerCode || rowData.company}</div>
                <div style="margin-top: 8px; font-weight: bold; margin-bottom: 4px;">From:</div>
                <div style="color: ${getStatusColor(currentStatusId)};">${currentStatus}</div>
                <div style="margin-top: 4px; font-weight: bold; margin-bottom: 4px;">To:</div>
                <div style="color: ${getStatusColor(newStatusId)}; font-weight: 600;">${selectedStatus?.statusName}</div>
                <div style="margin-top: 8px; font-weight: bold; margin-bottom: 4px;">Reason:</div>
                <div style="font-style: italic;">${Note}</div>
              </div>
            </div>
          `;
        } else {
          // 只更新date
          confirmTitle = 'Confirm Change';
          confirmHtml = `
            <div style="text-align: left;">
              <p>Are you sure you want to set the unconfirm date?</p>
              <div style="margin-top: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 4px;">
                <div style="font-weight: bold; margin-bottom: 4px;">Customer:</div>
                <div>${rowData.customerCode || rowData.company}</div>
                <div style="margin-top: 8px; font-weight: bold; margin-bottom: 4px;">Current Status:</div>
                <div style="color: ${getStatusColor(currentStatusId)};">${currentStatus}</div>
                <div style="margin-top: 8px; font-weight: bold; margin-bottom: 4px;">Unconfirm Date:</div>
                <div style="font-weight: 600;">${moment(unconfirmDate).format('DD/MM/YYYY')}</div>
              </div>
            </div>
          `;
        }

        // 二次确认
        const confirmResult = await Swal.fire({
          title: confirmTitle,
          html: confirmHtml,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Confirm',
          cancelButtonText: 'No, Cancel',
          confirmButtonColor: '#223B2A',
          allowOutsideClick: false,
          allowEscapeKey: false
        });

        if (confirmResult.isConfirmed) {
          const isUpdatingStatus = newStatusId && newStatusId !== currentStatusId;
          const isUpdatingDate = !!unconfirmDate;

          const apiUrl = buildUpdateCustomerStatusUrl(baseUrl, {
            customerId: rowData.customerId,
            statusId: isUpdatingStatus ? newStatusId : null,
            note: Note,
            unconfirmDate: isUpdatingDate ? unconfirmDate : '',
            employeeId: getUserId(),
          });

          await ApiRequest({
            url: apiUrl,
            method: 'put'
          });

          // 只在更新状态时发送邮件
          if (isUpdatingStatus && isValidEmail(Email)) {
            sendEmailToSales(rowData, Email, Note, newStatusId);
          }

          resetData();
        }
      }


  };
  
     
  const actionButtons: any = [
    {
      icon: 'ghost', //Button attr of Ant design (danger, ghost)
      tooltip: 'Attach',
      isFreeAction: false,
      onClick: (event: any, rowData: any) => {
        openDialog(attachmentManagementDialog, rowData)
      }
    },
    {
      icon: 'ghost', //Button attr of Ant design (danger, ghost)
      tooltip: 'Quote',
      isFreeAction: false,
      onClick: (event: any, rowData: any) => {
        openDialog(quotationManagementDialog, rowData)
      }
    },
    {
      icon: 'ghost', //Button attr of Ant design (danger, ghost)
      tooltip: 'Order',
      isFreeAction: false,
      onClick: (event: any, rowData: any) => {
        openDialog(orderManagementDialog, rowData)
      }
    },
    {
      icon: 'ghost', //Button attr of Ant design (danger, ghost)
      tooltip: 'Addr',
      isFreeAction: false,
      onClick: (event: any, rowData: any) => {
        openDialog(extraAddrDialog, rowData)
      }
    },
    {
      icon: 'ghost', //Button attr of Ant design (danger, ghost)
      tooltip: <ContactsOutlined />,
      isFreeAction: false,
      onClick: (event: any, rowData: any) => {
        openDialog(contactDialog, rowData)
      }
    }
  ]

  const openDialog = (dialogFn: any, rowData: any) => {
    setDialogContent(dialogFn(rowData.customerId))
    setDialogTitle(rowData.company + ' -- ' + rowData.customerCode)
    setOpen(true)
  }
  const getExtraButton = () => {
    const newCol = {
      title: 'Actions',
      field: 'Buttons',
      editable: 'never',
      render: (rowData: any) => (
        !props.salesView ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '6px', minWidth: '17rem' }}>
            {/* 3×2 网格：第一行 Orders/Quotes/Contacts，第二行 Address/Attach；
                同列按钮上下对齐、等宽 —— Orders↔Address，Quotes↔Attach */}
            {(() => {
              // 根据 last order date 计算按钮颜色
              const getOrdersButtonColor = (lastOrderDate: any) => {
                if (!lastOrderDate) return '#8c8c8c'; // 没有订单 - 灰色

                const now = moment();
                const lastDate = moment(lastOrderDate);
                const monthsDiff = now.diff(lastDate, 'months', true);

                if (monthsDiff <= 3) return '#52c41a'; // 3个月内 - 绿色
                if (monthsDiff <= 6) return '#faad14'; // 半年内 - 橙色
                if (monthsDiff <= 12) return '#f5222d'; // 1年内 - 红色
                return '#8c8c8c'; // 超过1年 - 灰色
              };

              // 获取 Order 按钮的 tooltip 内容
              const getOrdersButtonTooltip = (lastOrderDate: any) => {
                if (!lastOrderDate) {
                  return (
                    <div>
                      <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>Order Status Colors:</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#52c41a', borderRadius: '2px' }}></span>
                        <span>Within 3 months</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#faad14', borderRadius: '2px' }}></span>
                        <span>Within 6 months</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#f5222d', borderRadius: '2px' }}></span>
                        <span>Within 1 year</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#8c8c8c', borderRadius: '2px' }}></span>
                        <span>No orders / Over 1 year</span>
                      </div>
                      <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #eee', fontSize: '12px', color: '#666' }}>
                        Current: No order history
                      </div>
                    </div>
                  );
                }

                const now = moment();
                const lastDate = moment(lastOrderDate);
                const monthsDiff = now.diff(lastDate, 'months', true);

                let statusText = '';
                let statusColor = '';

                if (monthsDiff <= 3) {
                  statusText = 'Within 3 months';
                  statusColor = '#52c41a';
                } else if (monthsDiff <= 6) {
                  statusText = 'Within 6 months';
                  statusColor = '#faad14';
                } else if (monthsDiff <= 12) {
                  statusText = 'Within 1 year';
                  statusColor = '#f5222d';
                } else {
                  statusText = 'Over 1 year';
                  statusColor = '#8c8c8c';
                }

                return (
                  <div>
                    <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>Order Status Colors:</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
                      <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#52c41a', borderRadius: '2px' }}></span>
                      <span>Within 3 months</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
                      <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#faad14', borderRadius: '2px' }}></span>
                      <span>Within 6 months</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px' }}>
                      <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#f5222d', borderRadius: '2px' }}></span>
                      <span>Within 1 year</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#8c8c8c', borderRadius: '2px' }}></span>
                      <span>No orders / Over 1 year</span>
                    </div>
                    <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #eee', fontSize: '12px', color: '#666' }}>
                      Last Order: <span style={{ fontWeight: 'bold', color: statusColor, marginLeft: '4px' }}>{moment(lastOrderDate).format('DD/MM/YYYY')}</span>
                      <br />
                      Status: <span style={{ fontWeight: 'bold', color: statusColor, marginLeft: '4px' }}>{statusText}</span>
                      <span style={{ marginLeft: '4px' }}>({monthsDiff.toFixed(1)} months ago)</span>
                    </div>
                  </div>
                );
              };

              const ordersColor = getOrdersButtonColor(rowData.lastOrderDate);
              const tooltipContent = getOrdersButtonTooltip(rowData.lastOrderDate);

              return (
                <Tooltip title={tooltipContent} placement="right">
                  <Button
                    key={getRandomKey()}
                    style={{
                      backgroundColor: ordersColor,
                      borderColor: ordersColor,
                      color: '#FFFFFF'
                    }}
                    onClick={(event: any) => {
                      openDialog(orderManagementDialog, rowData);
                    }}
                  >
                    Orders
                  </Button>
                </Tooltip>
              );
            })()}

            <Button
              key={getRandomKey()}
              // type="primary"
              style={{ backgroundColor: '#13c2c2', borderColor: '#2196F3', color: '#FFFFFF' }}
              onClick={(event: any) => {
                openDialog(contactDialog, rowData);
              }}
            >
              Contacts
            </Button>
            <Button
              key={getRandomKey()}
              type="ghost"
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#FFFFFF' }}
              onClick={(event: any) => {
                openDialog(quotationManagementDialog, rowData);
              }}
            >
              Quotes
            </Button>
            <Button
              key={getRandomKey()}
              type="ghost"
              style={{ backgroundColor: '#722ed1', borderColor: '#2196F3', color: '#FFFFFF' }}
              onClick={(event: any) => {
                openDialog(extraAddrDialog, rowData);
              }}
            >
              Address
            </Button>
            <Button
              key={getRandomKey()}
              type={rowData.attachment && rowData.attachment.length >= 1 ? 'primary' : 'default'}
              style={{
                // Attach 占两列宽度，第二行与 Address 铺满整行
                gridColumn: 'span 2',
                backgroundColor: rowData.attachment && rowData.attachment.length >= 1 ? '#1890ff' : '#1890ff',
                borderColor: '#1890ff',
                color: '#FFFFFF',
                fontWeight: rowData.attachment && rowData.attachment.length >= 1 ? 'bold' : 'normal',
                boxShadow: rowData.attachment && rowData.attachment.length >= 1 ? '0 2px 8px rgba(24, 144, 255, 0.5)' : 'none'
              }}
              onClick={(event: any) => {
                openDialog(attachmentManagementDialog, rowData);
              }}
            >
              <FilePdfOutlined style={{ marginRight: '8px' }} />
              Attach
              {rowData.attachment && rowData.attachment.length >= 1 && (
                <span style={{
                  marginLeft: '8px',
                  backgroundColor: '#fff',
                  color: '#1890ff',
                  borderRadius: '10px',
                  padding: '2px 8px',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  {rowData.attachment.length}
                </span>
              )}
            </Button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Button
              key={getRandomKey()}
              // type="primary"
              style={{ marginBottom: '10px', backgroundColor: '#FF9800', borderColor: '#2196F3', color: '#FFFFFF' }}
              onClick={(event: any) => {
                openDialog(extraAddrDialog, rowData);
              }}
            >
              Address
            </Button>
          </div>
        )

      ),
    };
    return newCol;
  };
  
  
  const getCustomerManagementColumnModel = () =>{
    let ret =
    CustomerManagementColumnModel({updateCustomerStatus: updateCustomerStatus, isSalesCustomer: !!props.salesId, isSalesView: props.salesView});
    // console.log(ret)
    ret.push(getExtraButton())
    // console.log(ret)
    return ret
  }

  // 存储原始数据用于搜索恢复
  const originalDataRef = useRef<any[]>([])
  const isSearchingRef = useRef(false)
  const searchTextRef = useRef('')

  // 自定义搜索处理函数
  // const handleSearchChange = (searchText: string) => {
  //   console.log('🔍 handleSearchChange called:', searchText)
  //   searchTextRef.current = searchText

  //   // 如果没有搜索文本，恢复原始数据
  //   if (!searchText || searchText.trim() === '') {
  //     console.log('🔍 Clearing search, restoring original data:', originalDataRef.current.length)
  //     if (originalDataRef.current.length > 0) {
  //       setDisplayData(originalDataRef.current)
  //     }
  //     isSearchingRef.current = false
  //     return
  //   }

  //   // 如果是第一次搜索，保存当前显示的数据作为原始数据
  //   if (!isSearchingRef.current && originalDataRef.current.length === 0) {
  //     // 获取当前显示的数据
  //     const currentData = displayData || []
  //     if (currentData.length === 0) {
  //       console.log('🔍 No data available for search')
  //       return
  //     }
  //     console.log('🔍 First search, storing original data:', currentData.length)
  //     originalDataRef.current = [...currentData]
  //     isSearchingRef.current = true
  //   }

  //   // 执行搜索过滤
  //   const searchLower = searchText.toLowerCase().trim()
  //   const filteredData = originalDataRef.current.filter((row: any) => {
  //     const searchableContent = row.searchableContent || ''
  //     const searchTerms = searchLower.split(' ').filter((term: string) => term.length > 0)
  //     return searchTerms.every((term: string) => searchableContent.includes(term))
  //   })

  //   console.log('🔍 Search results:', filteredData.length, '/', originalDataRef.current.length)

  //   // 使用React state更新表格显示数据
  //   setDisplayData(filteredData)
  // }
  return (
    <div className="customer">
      <style>
      {`
        .MuiTableCell-root:nth-last-child(2) {
        position: sticky !important;
        right: 80px;
        background: #fff;
        z-index: 4;
        box-shadow: -6px 0 8px -6px rgba(0, 0, 0, 0.25);
        }
      `}
      </style>      
      <CommonTablePageWithSortPreserve
        externalData={displayData}
        urlInfoKey={ urlKey.Customer }
        title={props.salesView ? 'Customer' : ((props.salesId ? '' : 'All ') + 'Customer Management')}
        column={getCustomerManagementColumnModel() }
        tableRef={tableRef}
        mappingUpdateData={async (dataDetail: any, type: any) => {
          console.log(dataDetail)
          if (type === urlType.Delete) {
            const exceptionalPage = props.salesId ? 'Customer Only Sales' : 'Customer Management'
            const exceptionalTriggerReason = 'Delete customer: ' + dataDetail.customerCode
            // 删除客户属于非常规操作：先做授权验证（不写日志）
            const result = await SweetAlertService.warningConfirmVerifyOnly(exceptionalPage, exceptionalTriggerReason)
            if (!result || result.dismissed || !result.value) {
              return
            }
            try {
              await ApiRequest({ url: 'Customer/DeleteCustomer?id=' + dataDetail.customerId, method: 'delete' })
            } catch (error) {
              return
            }
            // 删除接口成功后，才写入非常规操作日志（取消授权/删除失败都不记录）
            await SweetAlertService.addExceptionalLog(
              exceptionalPage,
              exceptionalTriggerReason,
              result.value.reason,
              result.value.employeeId
            )
            return 'resolve'
          }
          dataDetail.deliveryFeeFlag = dataDetail.flagId  //patch for deliveryFeeFlagId
          // dataDetail.showPriceOnPackingSlip = dataDetail.showPriceOnPackingSlip==true?1:0;
          if (type === urlType.Update && props.salesView) {
            return
          }
          isCreate = type === urlType.Create
          if (props.salesId && isCreate) {
            dataDetail.employeeId = props.salesId
            dataDetail.paymentCycleId = 6
            dataDetail.statusId = 3
            dataDetail.leadRating = 3
          }
          if (!dataDetail.leadRating) {
            dataDetail.leadRating = 3
          }
          if (dataDetail.leadRating > 5) {
            SweetAlertService.errorMessage('Rating must be lower equal than 5.')
            return
          }
          return dataDetail
        }}
        mappingRenderData={(data: any) => {
          if (isCreate) {
            const newCustomer = data[data.length - 1]
            openDialog(extraAddrDialog, newCustomer)
            ApiRequest({url: 'OnlineUser/AddOnlineUser', method: 'post', data: {
              userName: newCustomer.customerNumber.toString(),
              password: '123456',
              customerId: newCustomer.customerId
            }})
          }

          let returnData = data.map((row: any) => {
            // 调试：检查员工数据
            // console.log('🔍 Row data - customerCode:', row.customerCode, 'employee:', row.employee)

            // 尝试多种可能的员工名字字段
            const employeeFirstName = row.employee?.firstName || row.employeeFirstName || row.salesFirstName || row.employeeName || ''
            const employeeLastName = row.employee?.lastName || row.employeeLastName || row.salesLastName || ''
            const employeeFullName = row.employee?.firstName + ' ' + row.employee?.lastName ||
                                   row.employeeFirstName + ' ' + row.employeeLastName ||
                                   row.employeeName || ''

            const searchableContent = [
              row.company || '',
              row.customerCode || '',
              row.customerNumber || '',
              row.mobile || '',
              row.phone || '',
              row.email || '',
              row.address1 || '',
              row.address2 || '',
              row.postalCode || '',
              row.notes || '',
              employeeFirstName,
              employeeLastName,
              employeeFullName
            ].join(' ').toLowerCase()

            // // 调试：检查 searchableContent
            // if (row.customerCode && row.customerCode.length < 10) { // 只显示前几条避免太多日志
            //   console.log('🔍 searchableContent for', row.customerCode, ':', searchableContent.substring(0, 200))
            // }

            return {
              ...row,
              createdAtDate: row.createdAt && (new Date(row.createdAt + '.000Z')).toDateString(),
              flagId : row.deliveryFeeFlag,
              searchableContent: searchableContent
            }
          })

          if (props.salesId) {
            returnData = returnData.filter((row: any) => row.employeeId === props.salesId)
          }

          // 🧪 测试：限制只返回前 3 条记录
          // console.log('🧪 TEST MODE - Limiting to 3 records for testing')
          // returnData = returnData.slice(0, 3)

          // ⭐⭐⭐ 在这里更新原始数据统计信息（filter 之前）
          setOriginalTotalCount(returnData.length)
          setOriginalActiveCount(returnData.filter((x:any) => x.statusId === 1).length)

          // 将数据存储到React state中，用于自定义搜索
          if (!isInitialized) {
            setDisplayData(returnData)
            setIsInitialized(true)
          }

          return returnData
        }}

        triggerResetData={triggerResetData}
        isNotAddable={props.salesView}
        isNotDeletable={props.salesView}
        isNotEditable={props.salesView}
        columnsButton={true}
        // onSearchChange={(searchText: string) => handleSearchChange(searchText)}
      />
      <CommonDialog open={open} title={dialogTitle} onDialogClose={() => setOpen(false)} dialogContent={dialogContent} />
      <CustomerStatsFooter
        tableRef={tableRef}
        originalTotalCount={originalTotalCount}
        originalActiveCount={originalActiveCount}
      />
    </div>
  )
}

export default CustomerManagementPage
